/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Complaints_TitleInputs */

const da_terms_complaints_title = /** @type {(inputs: Terms_Complaints_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klager og lovvalg`)
};

/** @type {(inputs: Terms_Complaints_TitleInputs) => LocalizedString} */
const en_terms_complaints_title = da_terms_complaints_title;

/**

* @param {Terms_Complaints_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_complaints_title = /** @type {((inputs?: Terms_Complaints_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Complaints_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_complaints_title(inputs)
	return /** @type {LocalizedString} */ ("Klager og lovvalg")
});